
import { Component, Vue } from 'vue-property-decorator'
import UserTable from './components/userTable.vue'
import { UserService } from '@/services/index'

@Component({
    name: 'UserAuthentications',
    components: {
        UserTable
    }
})
export default class extends Vue {
    private users = []
    private pageIndex: number = 1
    private pageSize: number = 50
    private pageTotal: number = 0
    private loading: boolean = false
    private tabStatus = 'authPedding'
    private statusOptions = [
        { key: 'authPedding', value: '申请认证中' },
        { key: 'authError', value: '认证失败' },
        { key: 'authSuccess', value: '已认证' }
    ]
    private mapCertStatus: any = {
        unAuth: 0,
        authPedding: 1,
        authSuccess: 2,
        authError: 3
    }

    private mounted() {
        this.getUsers()
    }

    private async getUsers() {
        const cert_status = this.mapCertStatus[this.tabStatus]
        const params = {
            cert_status,
            page_index: this.pageIndex, 
            page_size: this.pageSize
        }
        const result = await UserService.getNmUsers(params)
        if (result.status === 200) {
            this.users = result.data.users
            this.pageTotal = result.data.page_total
        }
    }

    private onTabClick() {
        this.pageIndex = 1
        this.getUsers()
    }

    private onCurrentChange(page: any) {
        const $backtop = this.$refs.backtop as any
        this.pageIndex = page
        this.getUsers()
        $backtop.scrollToTop()
    }
}
